export default class FeRoom {
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 房间ID
     */
    public roomId: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 房间编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 房间唯一ID
     */
    public uniqueNo: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 房间名称
     */
    public name: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 类型：1 教室，2会议室，3，行政办公 4：实验室 5：体育场馆
     */
    public type: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 类型名称：1 教室，2会议室，3，行政办公 4：实验室 5：体育场馆
     */
    public typeName: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 楼宇ID
     */
    public buildingId: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 楼宇名称
     */
    public buildingName: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 楼宇编号
     */
    public buildingNo: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 校区ID
     */
    public campusId: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 校区名称
     */
    public campusName: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 校区No
     */
    public campusNo: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 房间容量
     */
    public capacity: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 楼层ID
     */
    public floorId: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 物理的楼层数
     */
    public floorNumber: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 楼层名称
     */
    public floorName: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 房间label
     */
    public label: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 房间说明
     */
    public description: string;
    /**
     * @type {string}
     * @memberof FeRoom
     * @name 图片的URL的地址，使用逗号分隔
     */
    public picUrls: string;
    constructor({
        roomId = '',
        no = '',
        uniqueNo = '',
        name = '',
        type = '',
        typeName = '',
        buildingId = '',
        buildingName = '',
        buildingNo = '',
        campusId = '',
        campusName = '',
        campusNo = '',
        capacity = '',
        floorId = '',
        floorNumber = '',
        floorName = '',
        label = '',
        description = '',
        picUrls = ''
    } = {}) {
        this.roomId = roomId,
        this.no = no,
        this.uniqueNo = uniqueNo,
        this.name = name,
        this.type = type,
        this.typeName = typeName,
        this.buildingId = buildingId,
        this.buildingName = buildingName,
        this.buildingNo = buildingNo,
        this.campusId = campusId,
        this.campusName = campusName,
        this.campusNo = campusNo,
        this.capacity = capacity,
        this.floorId = floorId,
        this.floorNumber = floorNumber,
        this.floorName = floorName,
        this.label = label,
        this.description = description,
        this.picUrls = picUrls
    }
}